var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_tab2"
  }, [_c('div', {
    staticClass: "box_contain"
  }, [_c('pro-form', {
    ref: "yypz",
    attrs: {
      "columns": _vm.yypzConfig
    },
    model: {
      value: _vm.detail,
      callback: function ($$v) {
        _vm.detail = $$v;
      },
      expression: "detail"
    }
  }), _c('div', {
    staticClass: "save"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.yypzChange
    }
  }, [_vm._v($t("e32z2", "保存"))])], 1)], 1), _c('div', {
    staticClass: "line"
  }), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "progress"
  }, [_c('h1', [_vm._v($t("d1up8u4", "操作步骤"))]), _c('p', [_vm._v(` ${$t("8h3564", "1、登录")} `), _c('a', {
    attrs: {
      "href": "https://login.dingtalk.com/oauth2/challenge.htm?redirect_uri=https%3A%2F%2Fopen-dev.dingtalk.com%2Fdingtalk_sso_call_back%3Fcontinue%3Dhttps%253A%252F%252Fopen-dev.dingtalk.com%252F&response_type=code&client_id=dingbakuoyxavyp5ruxw&scope=openid+corpid",
      "target": "_blank"
    }
  }, [_vm._v($t("ingpna7", "钉钉开发者后台"))])]), _c('p', {
    staticClass: "ti2"
  }, [_vm._v($t("ld8cpym", "说明：只有管理员和子管理员可登录开发者后台。"))]), _c('p', [_vm._v(` ${$t("gl867d19", "2、如果没有创建过应用，请先在‘应用开发’页面，选择‘企业内部开发’，然后单击‘创建应用’")} `)]), _c('p', {
    staticClass: "ti2"
  }, [_c('img', {
    attrs: {
      "src": "https://app-1251575231.cos.ap-shanghai.myqcloud.com/portal/apps/config/p255125.png",
      "width": "90%"
    }
  })]), _c('p', [_vm._v($t("j588ehp", "3、填写应用的‘基本信息’，然后单击‘确定创建’。"))]), _c('p', {
    staticClass: "ti2"
  }, [_c('img', {
    attrs: {
      "src": "https://app-1251575231.cos.ap-shanghai.myqcloud.com/portal/apps/config/p255200.png",
      "width": "30%"
    }
  })]), _c('p', [_vm._v(` ${$t("3begku1a", "4、应用创建后，在基础信息页可获取AppKey和AppSecret。复制拷贝到上面对应位置；")} `)]), _c('p', {
    staticClass: "ti2"
  }, [_c('img', {
    attrs: {
      "src": "https://app-1251575231.cos.ap-shanghai.myqcloud.com/portal/apps/config/Foxmail20211019050605.png",
      "width": "90%"
    }
  })])]);
}];
export { render, staticRenderFns };